import { SpaceBetweenRow } from '@fox/layout/src/flex';
import { QuestionDescriptionRender } from '../../question-block/question-description';
import { CreatePersonBlockMetadata } from '../contracts';
import { QuestionLabelWrapper } from './styled-components';
type QuestionFieldProps = {
	component: (props: { meta?: CreatePersonBlockMetadata; value: string; onChange: (val: string) => void; addressTypeId?: number; type?: string; id: string }) => JSX.Element;
	value: string;
	tabIndex: number;
	onChange: (value: string) => void;
	meta?: CreatePersonBlockMetadata;
	description?: string;
	required?: boolean;
	titleComponent?: JSX.Element;
	id: string;
	//for the address field
	addressTypeId?: number;
	type?: string;
	hideLabel?: boolean;
};

export const QuestionField = (props: QuestionFieldProps) => {
	const { id, value, description, required, component, meta, onChange, addressTypeId, titleComponent, type, hideLabel } = props;
	const Comp = component;
	return (
		<div>
			<SpaceBetweenRow style={{ alignItems: 'flex-end' }}>
				{hideLabel ? (
					<></>
				) : (
					<QuestionLabelWrapper>
						<QuestionDescriptionRender id={props.id} required={required} value={description ?? ''} />
					</QuestionLabelWrapper>
				)}
				{titleComponent ? titleComponent : null}
			</SpaceBetweenRow>

			{Comp !== undefined ? <Comp value={value} meta={meta} onChange={onChange} addressTypeId={addressTypeId} id={id} type={type} /> : null}
		</div>
	);
};
